import React from 'react';
import YouTube from 'react-youtube';

import * as styles from './CarouselVideo.css';
import { Image } from '@cian/ui-kit/image';
import { YoutubeIcon } from './YoutubeIcon';

interface ICarouselVideoProps {
  isActive?: boolean;
  src: string;
}

interface ICarouselVideoState {
  isActive: boolean;
}

const YOUTUBE_LINK_REGEX = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

export class CarouselVideo extends React.Component<ICarouselVideoProps, ICarouselVideoState> {
  public state: ICarouselVideoState = {
    isActive: false,
  };

  public static getDerivedStateFromProps(props: ICarouselVideoProps, state: ICarouselVideoState) {
    if (state.isActive && props.isActive === false) {
      return { isActive: false };
    }

    return null;
  }

  public render() {
    const srcMatch = YOUTUBE_LINK_REGEX.exec(this.props.src);
    if (!srcMatch) {
      return null;
    }
    const videoId = srcMatch[1];

    const { isActive } = this.state;
    if (!isActive) {
      return this.renderPreview(videoId);
    }

    return this.renderPlayer(videoId);
  }

  private renderPreview = (videoId: string) => {
    const previewUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    return (
      <div className={styles['container']} onClick={this.handlePreviewClick}>
        <Image src={previewUrl} />
        <div className={styles['icon']}>
          <YoutubeIcon />
        </div>
      </div>
    );
  };

  private renderPlayer = (videoId: string) => {
    return (
      <YouTube
        containerClassName={styles['video-container']}
        videoId={videoId}
        opts={{
          width: '100%',
          height: '100%',
          playerVars: {
            autoplay: 1,
          },
        }}
      />
    );
  };

  private handlePreviewClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();

    this.setState({
      isActive: true,
    });
  };
}
